import StackedColumn from "./component";

export default StackedColumn;
